import React, { useState, useEffect } from "react";
import Navbar2 from "../Components/Navbar2";
import Footer2 from "../Components/Footer2";
import img from "../Assets/serv.png";
import img2 from "../Assets/Service 24_7-pana 4.png";
import { getOurServices } from "../Common/apis"
import {useNavigate} from 'react-router-dom'
import Aos from "aos";

function GisulServices() {
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()

    useEffect(() => {
        const fetchServices = async () => {
          try {
            const res = await getOurServices();
            setServices(res.data); // assuming API returns `data: []`
          } catch (err) {
            console.error("Error fetching services:", err);
          } finally {
            setLoading(false);
          }
        };
    
        fetchServices();
      }, []);
    
  return (
    <>
      <div className="new-home">
        <Navbar2 />
        <div className="grid md:grid-cols-2 grid-cols-1 md:gap-[100px] gap-[68px] md:pt-[50px] pt-[30px] md:px-[100px] px-[20px] md:pb-[60px] pb-[50px]">
          <div className="grid grid-cols-2 gap-[16px] gap-y-[26px]">
          {loading ? (
              <p>Loading services...</p>
            ) : (
              services.map((service) => (
                <div data-aos="fade-right" key={service._id} className="new-services-card" onClick={() => navigate(`/service/${service._id}`)}>
                  <img src={service.image} alt={service.title} />
                  <div className="ser-title">
                    <p>{service.title}</p>
                  </div>
                </div>
              ))
            )}
          </div>
          <div>
          <img data-aos="fade-right" alt="" src={img} />
          <img data-aos="fade-left" alt="" className="ser-2-img" src={img2} />
          </div>
        </div>
        {/* <div className="so-3-img">
          <img className="" src={img2} />
        </div> */}
        <Footer2 />
      </div>
    </>
  );
}

export default GisulServices;
